import React from 'react'
import './CreatorSettingsMembership.scss'
import CreatorSettingsHeader from './CreatorSettingsHeader'
import CreatorMembershipUpsert from 'components/CreatorMembershipUpsert/CreatorMembershipUpsert'
import { useSelector } from 'react-redux'
import { getMe } from 'store/selectors'
import { useGetUserApi } from 'api'
import Spinner from 'components/Spinner'

const CreatorSettingsMembership = () => {
  const me = useSelector((state) => getMe(state))
  const { data: user } = useGetUserApi({
    userId: me.get('id'),
  })

  const renderContent = () => {
    if (user == null) {
      return <Spinner light small />
    }

    return <CreatorMembershipUpsert user={user} />
  }

  return (
    <div className="CreatorSettingsMembership">
      <CreatorSettingsHeader description="Charge your members on a monthly basis." />
      {renderContent()}
    </div>
  )
}

export default CreatorSettingsMembership
